export const AGENCY_ZOOM_TASK_CREATE_TYPE_VALUES = [
  "todo",
  "email",
  "call",
  "meeting",
] as const;

export const AGENCY_ZOOM_TASK_CREATE_TYPE_LABEL_KEYS: Record<
  (typeof AGENCY_ZOOM_TASK_CREATE_TYPE_VALUES)[number],
  string
> = {
  todo: "agencyZoomCreateTaskSettings.typeTodo",
  email: "agencyZoomCreateTaskSettings.typeEmail",
  call: "agencyZoomCreateTaskSettings.typeCall",
  meeting: "agencyZoomCreateTaskSettings.typeMeeting",
};
